/* eslint-disable */
/**
 *
 * @param {number} id
 * @return {import('./models/BannerListItem').ArticleCategory}
 */
export function transformTypeIdToCategory(id) {
  switch (id) {
    case 1:
      return "news";
    case 2:
      return "activities";
    case 3:
      return "privileges";
    default:
      throw new Error("Article Type ID not supported");
  }
}

/**
 *
 * @param {import('../../clients/BaanRueJaiClient').BannerResponse} item
 *
 * @return {import('./models/BannerListItem').BannerListItem}
 */
export function transformBannerResponseToBannerListItem(item, pinnedBanners) {
  const id = item.article_id;
  const title = item.title;
  const content = item.content;
  const imageUrl = item.image_url;
  const category = transformTypeIdToCategory(item.articles_type_id);
  const isPinned = pinnedBanners.includes(item.article_id) ? true : false;

  return {
    id,
    title,
    content,
    imageUrl,
    category,
    isPinned
  };
}

export function transformArticlesResponseToListItem(item) {
  const id = item.articles_id;
  const title = item.title;
  const content = item.content;
  const cover = item.cover;
  const category = transformTypeIdToCategory(item.articles_type_id);

  return {
    id,
    title,
    content,
    cover,
    category
  };
}